import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

export type TabType = 'description' | 'specs' | 'delivery';

@Component({
    selector: 'app-product-description-tabs',
    standalone: true,
    imports: [CommonModule],
    template: `
    <div class="w-full flex flex-col gap-6 py-8">
      <!-- PESTAÑAS (TABS) -->
      <div class="flex items-center justify-center border-b border-gray-200 gap-8 text-sm sm:text-base">
        <button 
          (click)="activeTab = 'description'"
          [class.border-rose-500]="activeTab === 'description'"
          [class.text-rose-500]="activeTab === 'description'"
          [class.border-transparent]="activeTab !== 'description'"
          [class.text-gray-500]="activeTab !== 'description'"
          class="pb-3 border-b-2 font-bold transition-all cursor-pointer"
        >
          Descripción
        </button>

        <button 
          (click)="activeTab = 'specs'"
          [class.border-rose-500]="activeTab === 'specs'"
          [class.text-rose-500]="activeTab === 'specs'"
          [class.border-transparent]="activeTab !== 'specs'"
          [class.text-gray-500]="activeTab !== 'specs'"
          class="pb-3 border-b-2 font-bold transition-all cursor-pointer"
        >
          Especificaciones
        </button>

        <button 
          (click)="activeTab = 'delivery'"
          [class.border-rose-500]="activeTab === 'delivery'"
          [class.text-rose-500]="activeTab === 'delivery'"
          [class.border-transparent]="activeTab !== 'delivery'"
          [class.text-gray-500]="activeTab !== 'delivery'"
          class="pb-3 border-b-2 font-bold transition-all cursor-pointer"
        >
          Envío y Garantía
        </button>
      </div>

      <!-- CONTENIDO DE LAS PESTAÑAS -->
      <div class="bg-gray-50/60 p-6 sm:p-8 rounded-3xl border border-gray-100 text-sm text-gray-600 leading-relaxed">
        
        <!-- DESCRIPCIÓN -->
        <div *ngIf="activeTab === 'description'" class="flex flex-col gap-3">
          <h3 class="text-rose-500 font-bold text-base">{{ title }}</h3>
          <p>{{ description }}</p>
        </div>

        <!-- ESPECIFICACIONES -->
        <div *ngIf="activeTab === 'specs'" class="flex flex-col gap-2">
          <h4 class="font-bold text-gray-800 mb-1">Detalles del arreglo:</h4>
          <ul class="list-disc pl-5 flex flex-col gap-1.5">
            <li *ngFor="let item of specifications">{{ item }}</li>
          </ul>
        </div>

        <!-- ENVÍO Y GARANTÍA -->
        <div *ngIf="activeTab === 'delivery'" class="flex flex-col gap-4">
          <div>
            <h4 class="font-bold text-gray-800 mb-1">Delivery:</h4>
            <p>Realizamos envíos a Lima Metropolitana y Callao en 3 rangos horarios flexibles.</p>
          </div>
          <div>
            <h4 class="font-bold text-gray-800 mb-1">Promesa de Calidad:</h4>
            <p>Arreglos florales elaborados cuidadosamente con rosas y flores seleccionadas de la más alta calidad.</p>
          </div>
        </div>

      </div>
    </div>
  `
})
export class ProductDescriptionTabsComponent {
    @Input() title: string = '';
    @Input() description: string = '';
    @Input() specifications: string[] = [];

    activeTab: TabType = 'description';
}